import StructuredData from './StructuredData';

interface ArticleSchemaProps {
  headline: string;
  description?: string;
  image?: string | string[];
  datePublished: string;
  dateModified?: string;
  author?: {
    name: string;
    url?: string;
  };
  publisher?: {
    name: string;
    logo?: string;
  };
  url?: string;
}

const ArticleSchema: React.FC<ArticleSchemaProps> = ({
  headline,
  description,
  image,
  datePublished,
  dateModified,
  author,
  publisher = {
    name: 'EPEN Ltd.',
    logo: 'https://vxfx.io/epenfav.webp',
  },
  url,
}) => {
  const siteUrl = process.env.SITE_URL || 'https://vxfx.io';
  const articleUrl = url || `${siteUrl}/news/${headline.toLowerCase().replace(/\s+/g, '-')}`;
  const articleImage = image || `${siteUrl}/epenfav.webp`;

  const articleSchema: any = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline,
    ...(description && { description }),
    image: Array.isArray(image) ? image : [articleImage],
    datePublished,
    ...(dateModified && { dateModified }),
    ...(author && {
      author: {
        '@type': 'Person',
        name: author.name,
        ...(author.url && { url: author.url }),
      },
    }),
    publisher: {
      '@type': 'Organization',
      name: publisher.name,
      logo: {
        '@type': 'ImageObject',
        url: publisher.logo || `${siteUrl}/epenfav.webp`,
      },
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': articleUrl,
    },
  };

  return <StructuredData data={articleSchema} />;
};

export default ArticleSchema;
